var map = {
	"./1/room-1.jpg": "30eb",
	"./2/room-1.jpg": "469c",
	"./3/room-1.jpg": "d07e",
	"./4/room-1.jpg": "c273",
	"./5/room-1.jpg": "1ff2"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0afd";